// removed by extract-text-webpack-plugin
module.exports = {"Main":"confirmEmail__Main__2OT-9"};


//////////////////
// WEBPACK FOOTER
// ./src/Containers/ConfirmEmail/confirmEmail.css
// module id = 1685
// module chunks = 2